import { ValidationSummary } from 'devextreme-react/validation-summary';
import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	MaterialOrderBackButton,
	MaterialOrderExitButton,
	MaterialOrderFilesButton,
	MaterialOrderNotes,
	NewCFIInformationPanel,
	NewMaterialOrderPage,
	NewMaterialOrderProducts,
	RepricingButton,
	SubmitMaterialOrderButton
} from '../../../features/cfi/material-order';
import {
	PlumbingBanner,
	PostTemplateDrawingLink,
	RetailOrderInformationCards,
	RetailOrderPage,
	RetailOrderProducts,
	RetailOrderProgress
} from '../../../features/cfi/retail-order';
import '../../../css/order.scss';


export default function RetailOrderNewMaterialPage() {

	return (

		<RetailOrderPage>

			<PlumbingBanner />

			<RetailOrderInformationCards />

			<RetailOrderProgress />

			<NewMaterialOrderPage>

				<Toolbar className='button-toolbar'>
					<ToolbarItem location={'before'}>
						<MaterialOrderBackButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<SubmitMaterialOrderButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<RepricingButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<MaterialOrderFilesButton />
					</ToolbarItem>
					<ToolbarItem location={'before'}>
						<MaterialOrderExitButton />
					</ToolbarItem>
				</Toolbar>

				<ValidationSummary validationGroup='newMaterialOrderValidationGroup'></ValidationSummary>

				<Box>
					<Item ratio={1}>
						<NewCFIInformationPanel />
						<PostTemplateDrawingLink />
					</Item>
					<Item ratio={1}>
					</Item>
					<Item ratio={1}>
					</Item>
				</Box>

				<NewMaterialOrderProducts />

				<RetailOrderProducts showMaterialOrderInSummary={true} />

				<MaterialOrderNotes />

			</NewMaterialOrderPage>

		</RetailOrderPage>
	)
}
